interface UserWithRootAccounts {
  user_id: string;
  root_accounts?: string[];
}

export function getEffectiveRootAccounts(
  user: UserWithRootAccounts,
  options: {
    accountId?: string;
    completedAssignments?: string[] | Set<string>;
    pendingUnassignments?: string[];
  }
): string[] {
  const { accountId, completedAssignments = [], pendingUnassignments = [] } = options;

  const original = user.root_accounts || [];

  // Check if user was assigned in this session
  const wasAssigned =
    completedAssignments instanceof Set
      ? completedAssignments.has(user.user_id)
      : completedAssignments.includes(user.user_id);

  // Add the account if it was assigned in this session
  const withAssignments = wasAssigned && accountId ? [...original, accountId] : original;

  // Remove accounts that have pending unassignments for this user
  return withAssignments.filter((_id) => !pendingUnassignments.includes(user.user_id));
}

export function canUnassignUser(
  user: UserWithRootAccounts,
  options: {
    accountId?: string;
    completedAssignments?: string[] | Set<string>;
    pendingUnassignments?: string[];
  }
): boolean {
  const effectiveAccounts = getEffectiveRootAccounts(user, options);
  // Fallback: if empty or undefined, don't allow unassignment
  if (!effectiveAccounts || effectiveAccounts.length === 0) return false;
  return effectiveAccounts.length > 1;
}

export function getUnassignTooltip(canUnassign: boolean): string {
  return canUnassign
    ? 'Unassign user from this account'
    : 'Cannot unassign from last account. Delete user from Users page instead.';
}
